import { BasePresenter } from '../base/base.presenter';
import { IAuth } from '@interfaces/containers/auth.interface';
import { ISessionService, SessionService } from '@services/proyecta/session.service';
import { IConfig, SPEnvironment } from '@/config/config';
import { GraphService, IGetUserInfoRequest, IGraphService } from '@services/base/graph.service';
import { ILang, UserDTO, UserInfoDTO } from '@models/';
import { Enums, LocalStorageHelper, Utilities } from '@utils';
import { useSelector } from 'react-redux';
const config = require('@/config/config.json') as IConfig;

export class AuthPresenter extends BasePresenter<IAuth> {
    private clientSession: ISessionService;
    private graphService: IGraphService;
    private _langs: ILang[];
    private _currentUser: UserDTO;
    public constructor(view?: IAuth) {
        super(view);
        this.clientSession = new SessionService();
        this.graphService = new GraphService();
        this._langs = useSelector(this.context.sessionStore.selectLangs);
        this._currentUser = useSelector(this.context.sessionStore.selectUser);
    }

    public get langs() {
        return this._langs;
    }
    public get history() {
        return this.context.history;
    }

    public get userExist() {
        const currentUser = LocalStorageHelper.get<UserDTO>(Enums.LocalStorageKeys.currentUser);
        return !Utilities.isNullObject(currentUser);
    }

    public async getCurrentUser(userRequestInfo: IGetUserInfoRequest) {
        const [userInfo, langs] = await Promise.all([this.graphService.getCurrentUserInfo(userRequestInfo), this.clientSession.getLangs()]);
        this.syncDispatcher(this.context.sessionStore.actions.getCurrentUser(userInfo));
        LocalStorageHelper.set<UserDTO>(Enums.LocalStorageKeys.currentUser, userInfo);
        if (Utilities.isNullObject(LocalStorageHelper.get<ILang>(Enums.LocalStorageKeys.currentLang))) {
            let department = userInfo.currentUser.department;
            if (Utilities.isNullObject(department)) {
                department = Enums.LangLabels.ES;
            }
            const currentLang = langs.find(l => l.label.toUpperCase() === department.toUpperCase());
            LocalStorageHelper.set<ILang>(Enums.LocalStorageKeys.currentLang, currentLang);
            this.syncDispatcher(this.context.sessionStore.actions.setLang(currentLang));
        }
        window.location.href = "/";
    }

    public async getUserPhoto(userId: string) {
        const userPhoto = await this.graphService.getUserPhoto(userId);
        return userPhoto
    }

    public login() {
        const userRequestInfo: IGetUserInfoRequest = {
            properties: Object.keys(new UserInfoDTO()).join(',')
        };
        if (config.environment === SPEnvironment.local) {
            userRequestInfo.email = config.mockUser;
            this.getCurrentUser(userRequestInfo);
        } else {
            const url = `${config.proxy}/.auth/login/aad?post_login_redirect_url=/proyecta/post_login`;
            window.location.href = url;
        }
    }

    public async postLogin() {
        const userRequestInfo: IGetUserInfoRequest = {
            properties: Object.keys(new UserInfoDTO()).join(',')
        };
        userRequestInfo.email = await this.graphService.getAzureADCurrentUserEmail();
        await this.getCurrentUser(userRequestInfo);
    }

    public async validateLogin() {
        const currentUser = LocalStorageHelper.get<UserDTO>(Enums.LocalStorageKeys.currentUser);
        if (Utilities.isNullObject(currentUser)) {
            if (this.context.history.location.pathname.indexOf("proyecta/post_login") === -1 && this.context.history.location.pathname.indexOf("proyecta/logout") === -1) {
                this.context.history.push('/proyecta/login');
            }
        } else {
            this.syncDispatcher(this.context.sessionStore.actions.getCurrentUser(currentUser));
        }
    }
}